import { TDashboardEditComponent } from "MyDashboards/components/ComponentRegistry/types";
import useDashboardEditor from "MyDashboards/state/editor";
import { ColorRGB, Element, TextAlign } from "MyDashboards/state/editorTypes";
import px from "MyDashboards/utils/px";
import * as CSS from "csstype";
import RichTextInput from "qpr-base/ui/components/RichTextInput";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { HTMLtoParagraphs, paragraphsToHTML } from "./utils";
const useStyles = (bgProps: CSS.Properties) =>
  makeThemedStyles("MyDashboards.RichTextEditor", (theme) => ({
    dashboardsEditorContainer: {
      backgroundColor: "#8F8F8F !important",
      ...bgProps,
    },
  }));

const TextEditor: TDashboardEditComponent = ({
  el: activeElement,
  onChange,
}: {
  el: Element;
  onChange: (newElement: Partial<Element>) => void;
}) => {
  const activePage = useDashboardEditor((ed) =>
    ed.pages.find((p) => p.id === ed.selectedPageId)
  );
  const sf = useDashboardEditor((ed) => ed.scaleFactor);
  const [html, setHTML] = React.useState(() => paragraphsToHTML(activeElement));

  const [initialValue] = React.useState(() => paragraphsToHTML(activeElement));

  const classes = useStyles({
    backgroundSize: `${px((activePage?.width || 1) / sf)} ${px(
      (activePage?.height || 0) / sf
    )}`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: `${px(-activeElement.x / sf)} ${px(
      -activeElement.y / sf
    )}`,
    background: activePage
      ? `url(${getFileApiURL(`/cache/${activePage.bgPngRef}.png`)})`
      : "white",
    backgroundColor: "white",
  })();

  const pickColor = React.useMemo(() => {
    let defaultColor: ColorRGB = {
      r: 0,
      g: 0,
      b: 0,
    };
    activeElement?.paragraphs?.forEach((p) => {
      p.portions?.forEach((port) => {
        if (port.fillColor) {
          defaultColor = port.fillColor;
        }
      });
    });
    console.log("defaultColor", defaultColor);
    return defaultColor;
  }, [activeElement]);

  const pickFontSize: [number, string] = React.useMemo(() => {
    let fontSize: [number, string] = [16, "Dubai"];
    activeElement?.paragraphs?.forEach((p) => {
      p.portions?.forEach((port) => {
        if (port.fontSize) {
          fontSize[0] = port.fontSize;
        }
        if (port.fontName) {
          fontSize[1] = port.fontName;
        }
      });
    });
    return fontSize;
  }, [activeElement]);

  const pickTextAlignment: TextAlign = React.useMemo(() => {
    let textAlign: TextAlign = "start";
    activeElement?.paragraphs?.forEach((p) => {
      textAlign = p.textAlign as TextAlign;
    });
    return textAlign;
  }, [activeElement]);

  const saveValues = () => {
    const paragraphList = HTMLtoParagraphs(html, {
      fillColor: pickColor,
      fontSize: pickFontSize[0],
      fontName: pickFontSize[1],
      textAlign: pickTextAlignment,
    });

    if (paragraphList.length > 0) {
      onChange({
        component: undefined,
        paragraphs: paragraphList,
        rendered: {
          type: "text",
          value: "",
        },
      });
    }
  };
  React.useEffect(() => {
    const iv = window.setTimeout(() => {
      saveValues();
    }, 500);
    return () => window.clearInterval(iv);
  }, [html]);

  if (!activeElement || !activeElement.paragraphs) {
    return null;
  }
  return (
    <div>
      <RichTextInput
        onChange={(value) => {
          setHTML(value);
        }}
        value={initialValue}
        className={classes.dashboardsEditorContainer}
      />
    </div>
  );
};

export default TextEditor;
